module.exports = __webpack_public_path__ + "static/og-image-693f57bcf7e58f2fc881a807df3726d7.png";